import { render, staticRenderFns } from "./AboutSpousalSupportOrder.vue?vue&type=template&id=554f2482"
import script from "./AboutSpousalSupportOrder.vue?vue&type=script&lang=ts"
export * from "./AboutSpousalSupportOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports